<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <!-- 顶部 -->
      <div class="header">
        <div class="hd_left" @click="isCity = !isCity">
          <span>{{ city }}</span>
          <img src="../../assets/xia.png" alt="" />
        </div>
        <div class="hd_right">
          <select @change="selectService($event)">
            <option>All services</option>
            <option>Pre-loading / Discharging Survey</option>
            <option>On/Off Hire Bunker Survey/Bunker & Condition Survey</option>
            <option>Bunkering Survey</option>
            <option>Draft Survey</option>
            <option>Insurance Adjust Survey</option>
          </select>
          <p class="time">
            <el-date-picker v-model="time" type="daterange" range-separator="-"
                            start-placeholder="Start" end-placeholder="End" :editable="false"
                            :clearable="false" align="center" format="MM/dd"></el-date-picker>
          </p>
          <p class="search">
            <img src="../../assets/search.png" alt="" @click="fnsearch" />
          </p>
        </div>
      </div>
      <!-- 地区 -->
      <div class="city" v-if="isCity">
        <div class="city-left">
          <span :class="{ active: ctIndex == index }"
                v-for="(item, index) in continentList" :key="index"
                @click="goContinent(item, index)">
            {{ item.name }}
          </span>
        </div>
        <div class="city-right">
          <div class="li">
            <span v-for="(item, index) in countryList" :key="index"
                  :class="{ active: coIndex == index }"
                  @click="goCountry(item, index)">
              {{ item.name }}
            </span>
          </div>
          <div class="li">
            <span v-for="(item, index) in cityList" :key="index"
                  :class="{ active: ciIndex == index }" @click="goCity(index)">
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <el-carousel height="509px" indicator-position="none" arrow="never">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index"
                          @click.native="goSwiper(item, index)">
          <img style="object-fit: cover;" :src="item.pic" />
        </el-carousel-item>
      </el-carousel>
      <!-- 检验师列表 -->
      <div class="inspectorList" style="position: relative">
        <img src="../../assets/d.png" alt="" style="
            width: 6px;
            position: absolute;
            z-index: 1;
            left: 1%;
            top: 43px;
          " />

        <div class="list"
             style="border: 2px solid #1ba8e8; margin-top: 45px; box-shadow: 0 0 30px rgba(27, 168, 232, 0.3);">
          <div class="lt-top">
            <div class="lt-top-left"
                 style="position: relative; overflow: hidden; text-align: left">
              List of inspectors
              <img src="../../assets/yy.png" style="
                  width: 100%;
                  position: absolute;
                  width: 100%;
                  bottom: 0;
                  left: 10px;
                " alt="" />
            </div>
            <div class="lt-top-con">
              <select class="item" @change="selectLevel($event)">
                <option>All</option>
                <option>Primary</option>
                <option>Intermediate</option>
                <option>Senior</option>
                <option>Expert</option>
              </select>
              <div class="item" @click="getOrderNum">Order quantity</div>
              <div class="item" @click="getScore">Score</div>
              <div style="
                  border: 1px solid #1ba8e8;
                  display: flex;
                  height: 40px;
                  border-radius: 6px;
                  box-shadow: 0 0 15px rgba(27, 168, 232, 0.3);
                ">
                <input v-model="key" type="text"
                       style="background: none; border: none; color: #e0f0ff; padding-left: 10px;" />
                <div @click="sousuo" style="
                    box-shadow: 0 0 10px #1ba8e8 inset;
                    height: 100%;
                    width: 60px;
                    text-align: center;
                    line-height: 40px;
                    background: rgba(27, 168, 232, 0.2);
                  ">
                  <img style="margin-top: 6px" src="../../assets/search.png"
                       alt="" />
                </div>
              </div>
            </div>

            <div class="lt-top-right" @click="getseeMore">See more</div>
          </div>
          <div class="ul-bottom" style="max-height: 500px; overflow-y: scroll">
            <div class="lt-bottom">
              <div class="lt-bottom-item" v-for="(item, index) in jysList"
                   :key="index" @click="goDetails(item.serveId)">
                <img style="object-fit: cover;" v-if="item.icon"
                     :src="item.icon" />
                <img style="object-fit: cover;" v-else
                     src="../../assets/logo.png" />
                <div class="jys" v-if="item.level == 0">Junior</div>
                <div class="jys" v-if="item.level == 1">Intermediate</div>
                <div class="jys" v-if="item.level == 2">Senior</div>
                <div class="jys" v-if="item.level == 3">Expert</div>
                <div class="name" v-if="item.name">
                  {{ item.n1||'' }}***
                </div>
                <div class="order">{{ item.country }}</div>
                <div class="age">{{ item.workYear }} Year</div>
                <div class="star">{{ item.score }} Score</div>
                <div class="money">{{ item.mail }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 明星检验师 -->
      <div class="starInspector" style="position: relative">
        <img src="../../assets/d.png" alt="" style="
            width: 6px;
            position: absolute;
            z-index: 1;
            left: 1%;
            top: 43px;
          " />
        <div class="list">
          <div class="lt-top-left" style="position: relative; width: 267px">
            <div class="lt-top">
              <div style="text-align: left; font-size: 28px">Hot examiner</div>
            </div>
            <img src="../../assets/yy.png" style="
                width: 100%;
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 10px;
              " alt="" />
          </div>
          <div class="ul-bottom" style="max-height: 500px; overflow-y: scroll">
            <div class="lt-bottom">
              <div class="item" v-for="(item, index) in starList" :key="index"
                   @click="goDetails(item.serveId)">
                <img style="object-fit: cover;" v-if="item.icon"
                     :src="item.icon" />
                <img style="object-fit: cover;" v-else
                     src="../../assets/logo.png" />
                <div class="jys" v-if="item.level == 0">Junior</div>
                <div class="jys" v-if="item.level == 1">Intermediate</div>
                <div class="jys" v-if="item.level == 2">Senior</div>
                <div class="jys" v-if="item.level == 3">Expert</div>
                <div class="name" v-if="item.name">
                  {{ item.n1||'' }}***
                </div>
                <div class="order">{{ item.country }}</div>
                <div class="age">{{ item.workYear }} Year</div>
                <div class="star">{{ item.score }} Score</div>
                <div class="money">{{ item.mail }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- 列表排序 -->
      <div class="serviceList" style="position: relative">
        <img src="../../assets/d.png" alt="" style="
            width: 6px;
            position: absolute;
            z-index: 1;
            left: 1%;
            top: 71px;
          " />
        <div class="list">
          <div class="lt-top">
            <div class="lt-top-left" style="
                position: relative;
                overflow: hidden;
                text-align: left;
                font-size: 28px;
              ">
              List sort
              <img src="../../assets/yy.png" style="
                  width: 100%;
                  position: absolute;
                  width: 100%;
                  bottom: 0;
                  left: 10px;
                " alt="" />
            </div>
          </div>
          <div class="lt-bottom">
            <div class="lt-bm-head">
              <span>Serial number</span>
              <span>Serial picture</span>
              <span>Service name</span>
              <span class="so">Oil number</span>
            </div>
            <div class="lt-bm-footer">
              <div class="li" v-for="(item, index) in listJy" :key="index"
                   @click="goDetails(item.serveId)">
                <span>{{ index+1 }}</span>
                <span>
                  <img style="width: 40px;height: 40px;border-radius: 50%;object-fit: cover; border: 2px solid #1ba8e8; box-shadow: 0 0 15px rgba(27, 168, 232, 0.5);"
                       :src="item.icon"/>
                </span>
                <span>{{ item.name }}</span>
                <span>{{ item.total || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务列表 -->
      <div class="serviceList" style="position: relative">
        <img src="../../assets/d.png" alt="" style="
            width: 6px;
            position: absolute;
            z-index: 1;
            left: 1%;
            top: 71px;
          " />
        <div class="list">
          <div class="lt-top">
            <div class="lt-top-left" style="
                position: relative;
                overflow: hidden;
                text-align: left;
                font-size: 28px;
              ">
              Service item
              <img src="../../assets/yy.png" style="
                  width: 100%;
                  position: absolute;
                  width: 100%;
                  bottom: 0;
                  left: 10px;
                " alt="" />
            </div>
          </div>
          <div class="lt-bottom">
            <div class="lt-bm-head">
              <span>Serial number</span>
              <span>Service name</span>
              <span class="so">Order quantity</span>
            </div>
            <div class="lt-bm-footer">
              <div class="li" v-for="(item, index) in serveList" :key="index"
                   @click="goSeverList(item, index)">
                <span>{{ index + 1 }}</span>
                <span>{{ item.name }}</span>
                <span>{{ item.count || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 热门服务 -->
      <div class="hotService">
        <div class="list" style="padding-bottom: 10px; padding-right: 10px">
          <div class="lt-top">
            <div>Popular services</div>
          </div>
          <div class="lt-bottom" style="max-height: 500px; overflow-y: scroll">
            <div class="item" v-for="(item, index) in caseList" :key="index"
                 @click="goCaseDetails(item)">
              <div class="item-left"><img :src="item.pic[0]" alt="" /></div>
              <div class="item-right">
                <p class="title">{{ item.serveTitle }}</p>
                <div class="smallBox">
                  <span v-if="item.n1">Name：{{ item.n1||'' }}***</span>
                  <span v-else>Name：{{ item.name }}</span>
                  <span>Time：{{ item.time }}</span>
                  <span>Address：{{ item.address }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <navFooter></navFooter>
    <div class="kefu">
      <img src="../../assets/kefu1.png" @click="isKefu = !isKefu" />
    </div>
    <div class="kefuBox" style="width: 817px;">
      <kefu v-if="isKefu"></kefu>
    </div>

  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
import kefu from "../../components/kefu.vue";
export default {
  name: "index",
  components: {
    navTop,
    navFooter,
    kefu
  },
  data () {
    return {
      isKefu: false,
      key: "",
      isCity: false, //是否显示选择地区
      continentList: [], //洲
      ctIndex: 0, //洲下标
      continentId: "", //洲id
      countryList: [], //国家
      coIndex: 0, //国家下标
      countryId: "", //国id
      cityList: [], //城市
      ciIndex: -1, //城市下标
      service: "All services", //服务
      keyword: "", //关键词
      time: "", //时间
      city: "Work area", //地区
      swiperList: [], //轮播图
      type: 1, //检验师列表-查询排序
      level: 0, //检验师列表-级别
      jysList: [], //检验师列表
      starList: [], //明星检验师
      type2: 1, //服务列表-查询排序
      level2: 0, //服务列表-级别
      serveList: [], //服务列表
      serveHotList: [], //热门服务
      caseList: [], //案例列表
      listJy: []
    };
  },
  created () {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({ path: "/" });
    } else {
      this.getSlideshow();
      this.getAreafirst();
      this.getList();
      this.getListstar();
      this.getServe();
      this.getServeHot();
      this.getCaseList();
      this.getListJy();
    }
  },
  methods: {
    async getCaseList () {
      let xhr = await this.$api.contentAl({
        nowPage: 0,
        pageCount: 10000,
      });
      if (xhr.result == 0) {
        xhr.data.list.forEach((element) => {
          if (element.pic) {
            element.pic = element.pic.split("|");
          } else {
            element.pic = [];
          }
        });
        this.caseList = xhr.data.list;
      }
    },
    getAreafirst () {
      let data = {};
      this.$api.areafirst(data).then((res) => {
        if (res.result == 0) {
          this.continentList = res.dataList;
          this.continentId = res.dataList[0].id;
          this.getAreasecond();
        }
      });
    },
    getAreasecond () {
      let data = {
        id: this.continentId,
      };
      this.$api.areasecond(data).then((res) => {
        if (res.result == 0) {
          this.countryList = res.dataList;
          this.countryId = res.dataList[0].id;
          this.getAreathird();
        }
      });
    },
    getAreathird() {
      let data = {
        id: this.countryId,
      };
      this.$api.areathird(data).then((res) => {
        if (res.result == 0) {
          this.cityList = res.dataList;
        }
      });
    },
    getSlideshow() {
      let data = {};
      this.$api.slideshow(data).then((res) => {
        if (res.result == 0) {
          this.swiperList = res.dataList;
        }
      });
    },
    goContinent(item, i) {
      this.ctIndex = i;
      this.coIndex = 0;
      this.ciIndex = -1;
      this.continentId = item.id;
      this.getAreasecond();
    },
    goCountry(item, i) {
      this.coIndex = i;
      this.countryId = item.id;
      this.getAreathird();
    },
    goCity(i) {
      this.ciIndex = i;
      this.isCity = false;
      this.city = this.cityList[i].name;
    },
    selectService(e) {
      this.service = e.target.value;
    },
    fnsearch() {
      if (this.city == "Work area") {
        this.$message({
          message: "Please select work area",
          type: "error",
          center: true,
          duration: 1000,
        });
        return;
      }
      if (this.time == "") {
        this.$message({
          message: "Please select a time",
          type: "error",
          center: true,
          duration: 1000,
        });
        return;
      }
      let obj = {
        city: this.city,
        service: this.service,
        keyword: "",
        time: this.time,
      };
      let {href} = this.$router.resolve({path: "/search", query: obj});
      window.open(href, "_blank");
    },
    goSwiper(item, i) {
      if (!item.serve.id) {
        if (item.url) {
          window.open(item.url);
        }
      } else {
        let {href} = this.$router.resolve({
          path: "/detail",
          query: {id: item.serve.id},
        });
        window.open(href, "_blank");
      }
    },
    selectLevel(e) {
      this.type = 0;
      if (e.target.value == "Primary") {
        this.level = 0;
      } else if (e.target.value == "Intermediate") {
        this.level = 1;
      } else if (e.target.value == "Senior") {
        this.level = 2;
      } else if (e.target.value == "Expert") {
        this.level = 3;
      } else if (e.target.value == "All") {
        this.level = 4;
      }
      this.getList();
    },
    getOrderNum() {
      this.type = 1;
      this.getList();
    },
    getScore() {
      this.type = 2;
      this.getList();
    },
    getList(istrue) {
      let data = {
        type: this.type,
        level: this.level,
        nowPage: 0,
        pageCount: 60,
      };
      if (istrue) {
        data.key = this.key;
      }
      this.$api.list(data).then((res) => {
        if (res.result == 0) {
          this.jysList = res.data.list;
        } else {
          this.jysList = [];
        }
      });
    },
    sousuo() {
      if (this.key) {
        this.getList(true);
      } else {
        this.getList(false);
      }
    },
    getseeMore() {
      let {href} = this.$router.resolve({path: "/search"});
      window.open(href, "_blank");
    },
    getListstar() {
      this.$api.liststar({}).then((res) => {
        if (res.result == 0) {
          this.starList = res.dataList;
          if (this.starList.length > 3) {
            this.starList.splice(2, this.starList.length - 3);
          }
        }
      });
    },
    selectLevel2(e) {
      this.type2 = 0;
      if (e.target.value == "Primary") {
        this.level2 = 0;
      } else if (e.target.value == "Intermediate") {
        this.level2 = 1;
      } else if (e.target.value == "Senior") {
        this.level2 = 2;
      } else if (e.target.value == "Expert") {
        this.level2 = 3;
      } else if (e.target.value == "All") {
        this.level2 = 4;
      }
      this.getServe();
    },
    getOrderNum2() {
      this.type2 = 1;
      this.getServe();
    },
    getScore2() {
      this.type2 = 2;
      this.getServe();
    },
    getServe() {
      let data = {
        type: this.type2,
        level: this.level2,
        nowPage: 1,
        pageCount: 30,
      };
      this.$api.serveList(data).then((res) => {
        if (res.result == 0) {
          this.serveList = res.data;
        }
      });
    },
    getServeHot() {
      let data = {};
      this.$api.serveHot(data).then((res) => {
        if (res.result == 0) {
          this.serveHotList = res.dataList;
        }
      });
    },
    goSeverList(item, index) {
      let {href} = this.$router.resolve({
        path: "/serveList",
        query: {
          ...item,
          id: index,
        },
      });
      window.open(href, "_blank");
    },
    goCaseDetails(item) {
      let {href} = this.$router.resolve({
        path: "/HomeCaseDetails",
        query: {id: item.id},
      });
      window.open(href, "_blank");
    },
    goDetails(id) {
      let {href} = this.$router.resolve({
        path: "/detail",
        query: {id: id},
      });
      window.open(href, "_blank");
    },
    getListJy() {
      this.$api.listJy({}).then((res) => {
        if (res.result == 0) {
          this.listJy = res.dataList;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

// 导航栏样式
::v-deep .nav {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-bottom: 2px solid $blue-primary !important;
  box-shadow: 0 5px 25px $blue-glow !important;

  .nav-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }
  }

  .nav-center {
    .li {
      color: #c0e4ff !important;
      text-shadow: 0 0 5px $blue-glow;

      &:hover {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      &.router-link-active {
        color: $blue-primary !important;
        border-bottom-color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .nav-right {
    .user {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 15px $blue-glow;

      &:hover {
        background: rgba(27, 168, 232, 0.1) !important;
      }
    }

    .language {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 15px $blue-glow;

      &:hover {
        background: rgba(27, 168, 232, 0.1) !important;
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

.kefuBox {
  position: fixed;
  bottom: 0px;
  right: 280px;
  z-index: 100;
  overflow: hidden;

  ::v-deep .pages {
    background: none !important;
    padding-bottom: 0;

    .content {
      background-image: none !important;
      position: relative;
    }

    .content::after {
      background-image: url(../../assets/kefu-bg.png);
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      width: 817px;
      height: 821px;
      transform: rotate(90deg);
      filter: hue-rotate(190deg) brightness(1.1) saturate(1.2);
    }
  }
}

.kefu {
  position: fixed;
  bottom: 20px;
  right: 115px;
  width: 130px;
  height: 130px;
  filter: drop-shadow(0 0 15px $blue-glow);

  img {
    width: 130px;
    height: 130px;
    display: block;
  }
}

.ul-bottom::-webkit-scrollbar {
  width: 0px;
}

.ul-bottom::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: $blue-primary;
}

.ul-bottom::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.2);
}

// 最外层
.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    margin-bottom: 76px;
    position: relative;

    .header {
      padding: 25px 0 30px 125px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .hd_left {
        width: 240px;
        height: 35px;
        border: 1px solid $blue-primary-rgba;
        box-sizing: border-box;
        background: rgba(15, 43, 63, 0.8);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 0 20px $blue-glow;

        span {
          font-size: 20px;
          color: $blue-primary;
          text-shadow: $text-glow;
        }

        img {
          width: 19px;
          height: 10px;
          display: block;
          margin-left: 9px;
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }

      .hd_right {
        height: 40px;
        background: rgba(15, 43, 63, 0.9);
        backdrop-filter: blur(5px);
        border: 1px solid $blue-primary-rgba;
        border-radius: 30px;
        display: flex;
        align-items: center;
        box-shadow: 0 0 30px $blue-glow;
        margin-right: 40px;

        select {
          width: 140px;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
          border: none;
          outline: none;
          color: $blue-primary;
          padding-left: 12px;
          box-sizing: border-box;
          font-size: 20px;
          font-weight: 500;
          border-right: 1px solid $blue-primary-rgba;
          border-radius: 30px 0 0 30px;

          option {
            background: #1a3f5a;
            color: $blue-primary;
            font-size: 20px;
          }
        }

        .time {
          height: 38px;
          width: 153px;
          margin-left: 1px;
          color: $blue-primary;
          text-align: center;
          line-height: 38px;
          box-sizing: border-box;

          ::v-deep .el-date-editor--daterange {
            width: auto;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgba(15, 43, 63, 0.5);
            border: none;
            padding: 0;

            .el-input__icon {
              display: none;
            }

            .el-range-input {
              flex: 1;
              background: transparent;
              color: $blue-primary;
              font-size: 20px;
              font-weight: 500;
            }

            .el-range-separator {
              padding: 0;
              color: $blue-primary;
              line-height: 40px;
            }

            input::-webkit-input-placeholder {
              color: rgba(27, 168, 232, 0.6);
            }
          }
        }

        .search {
          width: 46px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(27, 168, 232, 0.2);
          border-radius: 0 30px 30px 0;

          img {
            filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
          }
        }
      }
    }

    .city {
      width: 100%;
      box-shadow: 0 0 50px $blue-glow;
      background: rgba(15, 43, 63, 0.95);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      border-radius: 20px;
      position: absolute;
      top: 82px;
      left: 0;
      padding: 38px 27px 77px 57px;
      box-sizing: border-box;
      display: flex;
      z-index: 99;

      .city-left {
        display: flex;
        flex-direction: column;

        span {
          width: 96px;
          height: 30px;
          font-size: 21px;
          color: #c0e4ff;
          text-align: center;
          line-height: 30px;
          margin-bottom: 65px;
          box-sizing: border-box;
          transition: all 0.3s ease;
        }

        .active {
          background: $blue-glow;
          border: 1px solid $blue-primary-rgba;
          box-shadow: 0 0 20px $blue-primary;
        }
      }

      .city-right {
        margin-left: 39px;
        display: flex;

        .li {
          height: 500px;
          overflow-y: scroll;
          width: 300px;

          &::-webkit-scrollbar {
            width: 4px;
          }

          &::-webkit-scrollbar-thumb {
            background: $blue-primary;
            border-radius: 2px;
          }

          span {
            display: block;
            padding: 0 10px;
            height: 30px;
            font-size: 21px;
            color: #c0e4ff;
            text-align: center;
            line-height: 30px;
            box-sizing: border-box;
            margin-bottom: 25px;
            transition: all 0.3s ease;

            &:hover {
              color: $blue-primary;
              text-shadow: $text-glow;
            }
          }

          .active {
            background: $blue-glow;
            border: 1px solid $blue-primary-rgba;
            box-shadow: 0 0 20px $blue-primary;
          }
        }

        p {
          font-size: 30px;
          color: $blue-primary;
          padding-left: 17px;
          box-sizing: border-box;
          margin-bottom: 32px;
          text-shadow: $text-glow;
        }
      }
    }

    .el-carousel__item {
      background: linear-gradient(135deg, #1a3f5a 0%, #0f2b3f 100%);
      border-radius: 20px;
      padding: 32px 12px 32px 24px;
      box-sizing: border-box;
      box-shadow: 0 0 50px $blue-glow;

      img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 10px;
      }
    }

    .inspectorList {
      width: 100%;
      margin-top: 48px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border-radius: 40px;
      padding: 26px 56px 61px 54px;
      box-sizing: border-box;
      box-shadow: 0 0 60px $blue-glow;

      .list {
        width: 100%;
        border-radius: 31px;
        box-sizing: border-box;

        .lt-top {
          padding: 0 44px 0 0;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 70px;
          margin-top: -5px;

          .lt-top-left {
            width: 277px;
            height: 48px;
            background: linear-gradient(90deg, $blue-primary 0%, transparent 100%);
            border-radius: 24px 0 24px 0;
            padding-left: 33px;
            box-sizing: border-box;
            font-size: 28px;
            font-weight: bold;
            color: #fff;
            text-shadow: $text-glow;
            line-height: 48px;
            margin-top: -10px;
          }

          .lt-top-con {
            display: flex;
            align-items: center;

            .item {
              height: 35px;
              border: 1px solid $blue-primary-rgba;
              outline: none;
              background: rgba(27, 168, 232, 0.1);
              box-shadow: 0 0 15px $blue-glow;
              font-size: 20px;
              color: $blue-primary;
              padding: 0 15px;
              box-sizing: border-box;
              margin-right: 40px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-radius: 6px;
              cursor: pointer;
              transition: all 0.3s ease;

              &:hover {
                background: rgba(27, 168, 232, 0.2);
                box-shadow: 0 0 25px $blue-primary;
              }

              option {
                background: #1a3f5a;
                color: $blue-primary;
                font-size: 20px;
              }

              p {
                font-size: 20px;
                color: $blue-primary;
              }

              img {
                width: 15px;
                height: 21px;
                display: block;
              }
            }

            .item:last-child {
              margin-right: 0;
            }
          }

          .lt-top-right {
            width: 145px;
            height: 36px;
            background: $blue-glow;
            border: 1px solid $blue-primary-rgba;
            font-size: 21px;
            color: #c0e4ff;
            line-height: 36px;
            text-align: center;
            box-shadow: 0 0 20px $blue-primary;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
              background: rgba(27, 168, 232, 0.7);
              box-shadow: 0 0 30px $blue-primary;
              color: #fff;
            }
          }
        }

        .lt-bottom {
          padding: 20px 20px 30px;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 18px;
          width: 100%;

          .lt-bottom-item {
            width: 100%;
            height: 220px;
            background: linear-gradient(135deg, rgba(27, 168, 232, 0.1) 0%, rgba(15, 43, 63, 0.95) 100%);
            border: 1px solid $blue-primary-rgba;
            border-radius: 16px;
            position: relative;
            box-shadow: 0 0 20px $blue-glow;
            transition: all 0.3s ease;
            margin: 0;
            overflow: hidden;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 30px $blue-primary;
            }

            img {
              width: 85px;
              height: 85px;
              background: linear-gradient(135deg, $blue-primary 0%, #fff 100%);
              border-radius: 50%;
              position: absolute;
              top: 15px;
              left: 15px;
              border: 2px solid $blue-primary;
              box-shadow: 0 0 20px $blue-primary;
              object-fit: cover;
            }

            .jys {
              min-width: 70px;
              padding: 5px 14px;
              word-break: break-all;
              background: rgba(27, 168, 232, 0.25);
              border: 1px solid $blue-primary-rgba;
              border-radius: 20px;
              font-size: 13px;
              font-weight: 600;
              color: #ffffff;
              text-align: center;
              position: absolute;
              bottom: 12px;
              left: 115px;
              box-shadow: 0 0 12px $blue-glow;
              white-space: nowrap;
              letter-spacing: 0.5px;
              backdrop-filter: blur(2px);
            }

            .name {
              font-size: 17px;
              font-weight: bold;
              color: #ffffff;
              text-shadow: 0 0 10px $blue-primary;
              position: absolute;
              top: 18px;
              left: 115px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 130px);
            }

            .order {
              font-size: 15px;
              color: #c0e4ff;
              position: absolute;
              top: 48px;
              left: 115px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 130px);
              font-weight: 400;
              opacity: 0.95;
            }

            .age {
              font-size: 15px;
              color: #c0e4ff;
              position: absolute;
              top: 74px;
              left: 115px;
              font-weight: 400;
              opacity: 0.95;
            }

            .star {
              font-size: 15px;
              color: #c0e4ff;
              position: absolute;
              top: 100px;
              left: 115px;
              font-weight: 400;
              opacity: 0.95;
            }

            .money {
              font-size: 14px;
              color: #c0e4ff;
              position: absolute;
              top: 126px;
              left: 115px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 130px);
              font-weight: 400;
              opacity: 0.9;
              font-style: italic;
            }
          }
        }
      }
    }

    .starInspector {
      margin-top: 20px;
      width: 100%;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border-radius: 40px;
      padding: 70px 52px 44px 60px;
      box-sizing: border-box;
      box-shadow: 0 0 60px $blue-glow;

      .list {
        width: 100%;
        border-radius: 31px;
        border: 1px solid $blue-primary-rgba;
        box-shadow: 0 0 50px $blue-glow inset;
        box-sizing: border-box;

        .lt-top {
          padding: 15px 0 0;
          box-sizing: border-box;

          div {
            width: 277px;
            height: 48px;
            background: linear-gradient(90deg, $blue-primary 0%, transparent 100%);
            border-radius: 24px 0 24px 0;
            font-size: 30px;
            padding-left: 33px;
            box-sizing: border-box;
            font-weight: bold;
            color: #fff;
            text-shadow: $text-glow;
            line-height: 48px;
          }
        }

        .lt-bottom {
          padding: 20px 20px 30px;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 18px;

          .item {
            width: 100%;
            height: 220px;
            background: linear-gradient(135deg, rgba(27, 168, 232, 0.1) 0%, rgba(15, 43, 63, 0.95) 100%);
            border: 1px solid $blue-primary-rgba;
            border-radius: 16px;
            position: relative;
            box-shadow: 0 0 20px $blue-glow;
            transition: all 0.3s ease;
            overflow: hidden;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 30px $blue-primary;
            }

            img {
              width: 85px;
              height: 85px;
              background: linear-gradient(135deg, $blue-primary 0%, #fff 100%);
              border-radius: 50%;
              position: absolute;
              top: 15px;
              left: 15px;
              border: 2px solid $blue-primary;
              box-shadow: 0 0 20px $blue-primary;
              object-fit: cover;
            }

            .jys {
              min-width: 70px;
              padding: 5px 14px;
              word-break: break-all;
              background: rgba(27, 168, 232, 0.25);
              border: 1px solid $blue-primary-rgba;
              border-radius: 20px;
              font-size: 13px;
              font-weight: 600;
              color: #ffffff;
              text-align: center;
              position: absolute;
              bottom: 12px;
              left: 115px;
              box-shadow: 0 0 12px $blue-glow;
              white-space: nowrap;
              letter-spacing: 0.5px;
              backdrop-filter: blur(2px);
            }

            .name {
              font-size: 17px;
              font-weight: bold;
              color: #ffffff;
              text-shadow: 0 0 10px $blue-primary;
              position: absolute;
              top: 18px;
              left: 115px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 130px);
            }

            .order {
              font-size: 15px;
              color: #c0e4ff;
              position: absolute;
              top: 48px;
              left: 115px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 130px);
              font-weight: 400;
              opacity: 0.95;
            }

            .age {
              font-size: 15px;
              color: #c0e4ff;
              position: absolute;
              top: 74px;
              left: 115px;
              font-weight: 400;
              opacity: 0.95;
            }

            .star {
              font-size: 15px;
              color: #c0e4ff;
              position: absolute;
              top: 100px;
              left: 115px;
              font-weight: 400;
              opacity: 0.95;
            }

            .money {
              font-size: 14px;
              color: #c0e4ff;
              position: absolute;
              top: 126px;
              left: 115px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: calc(100% - 130px);
              font-weight: 400;
              opacity: 0.9;
              font-style: italic;
            }
          }
        }
      }
    }

    .serviceList {
      margin-top: 20px;
      width: 100%;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border-radius: 40px;
      padding: 85px 56px 60px 56px;
      box-sizing: border-box;
      box-shadow: 0 0 60px $blue-glow;

      .list {
        width: 100%;
        border-radius: 31px;
        border: 1px solid $blue-primary-rgba;
        box-shadow: 0 0 50px $blue-glow inset;
        box-sizing: border-box;

        .lt-top {
          padding: 15px 44px 0 0;
          box-sizing: border-box;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;

          .lt-top-left {
            width: 277px;
            height: 48px;
            background: linear-gradient(90deg, $blue-primary 0%, transparent 100%);
            border-radius: 24px 0 24px 0;
            font-size: 30px;
            font-weight: bold;
            color: #fff;
            text-shadow: $text-glow;
            padding-left: 33px;
            line-height: 48px;
            box-sizing: border-box;
          }
        }

        .lt-bottom {
          padding: 40px 30px 30px;
          box-sizing: border-box;

          .lt-bm-head {
            width: 100%;
            height: 48px;
            background: linear-gradient(90deg, $blue-primary 0%, $blue-secondary 100%);
            border-radius: 10px 10px 0px 0px;
            display: flex;
            align-items: center;
            padding-right: 17px;
            box-sizing: border-box;
            box-shadow: 0 0 25px $blue-primary;

            span {
              display: block;
              text-align: center;
              font-size: 16px;
              color: #ffffff;
              font-weight: bold;
              text-shadow: $text-glow;
            }

            span:nth-child(1) {
              width: 15%;
            }

            span:nth-child(2) {
              width: 45%;
            }

            span:nth-child(3) {
              width: 40%;
            }

            span:nth-child(4) {
              width: 27%;
            }
          }

          .lt-bm-footer {
            max-height: 350px;
            width: 100%;
            overflow-y: auto;

            .li {
              height: 55px;
              display: flex;
              align-items: center;
              border-bottom: 1px solid rgba(27, 168, 232, 0.2);
              transition: all 0.3s ease;
              cursor: pointer;
              padding: 5px 0;

              &:hover {
                background: rgba(27, 168, 232, 0.1);
                box-shadow: 0 0 20px $blue-glow;
              }

              span {
                display: block;
                text-align: center;
                font-size: 15px;
                color: #c0e4ff;
              }

              span:nth-child(1) {
                width: 15%;
                color: $blue-primary;
              }

              span:nth-child(2) {
                width: 45%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              span:nth-child(3) {
                width: 40%;
              }

              span:nth-child(4) {
                width: 27%;
              }
            }
          }
        }
      }
    }

    .hotService {
      margin-top: 20px;
      width: 100%;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border-radius: 40px;
      padding: 100px 56px 70px 55px;
      box-sizing: border-box;
      box-shadow: 0 0 60px $blue-glow;

      .list {
        width: 100%;
        border-radius: 25px;
        border: 1px solid $blue-primary-rgba;
        box-shadow: 0 0 50px $blue-glow inset;
        box-sizing: border-box;
        margin-top: 40px;

        .lt-top {
          padding: 15px 0 0;
          box-sizing: border-box;

          div {
            width: 277px;
            height: 48px;
            background: linear-gradient(90deg, $blue-primary 0%, transparent 100%);
            border-radius: 24px 0 24px 0;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            text-shadow: $text-glow;
            text-align: center;
            padding-left: 33px;
            box-sizing: border-box;
            line-height: 48px;
          }
        }

        .lt-bottom {
          padding: 30px 20px;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;

          .item {
            width: 100%;
            height: 170px;
            position: relative;
            display: flex;
            align-items: flex-start;
            transition: all 0.3s ease;

            &:hover {
              transform: scale(1.02);
              filter: drop-shadow(0 0 25px $blue-primary);
            }

            .item-left {
              width: 180px;
              height: 120px;
              background: linear-gradient(135deg, $blue-primary 0%, $blue-secondary 100%);
              border-radius: 10px;
              padding: 10px;
              box-sizing: border-box;
              box-shadow: 0 0 25px $blue-glow;
              z-index: 2;
              flex-shrink: 0;

              img {
                width: 100%;
                height: 100%;
                display: block;
                border-radius: 5px;
                object-fit: cover;
              }
            }

            .item-right {
              margin-left: -20px;
              width: 100%;
              height: 140px;
              background: rgba(27, 168, 232, 0.1);
              border: 1px solid $blue-primary-rgba;
              border-radius: 10px;
              margin-top: 5px;
              box-sizing: border-box;
              box-shadow: 0 0 20px $blue-glow;
              position: relative;
              z-index: 1;
              padding-left: 25px;

              .title {
                font-size: 16px;
                font-weight: 400;
                color: #c0e4ff;
                position: absolute;
                top: -15px;
                right: 10px;
                width: 160px;
                padding: 5px 10px;
                box-sizing: border-box;
                text-align: center;
                height: 30px;
                line-height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                background: rgba(27, 168, 232, 0.3);
                border-radius: 15px;
                box-shadow: 0 0 15px $blue-glow;
              }

              .smallBox {
                width: calc(100% - 15px);
                height: 100px;
                background: rgba(27, 168, 232, 0.15);
                border: 1px solid $blue-primary-rgba;
                position: absolute;
                bottom: 15px;
                right: 8px;
                padding: 12px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                gap: 6px;
                border-radius: 8px;
                box-shadow: 0 0 20px $blue-glow inset;

                span {
                  color: #c0e4ff;
                  text-shadow: $text-glow;
                  font-size: 12px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>